import { useEffect, FC } from 'react';

interface GrowthBookAnalyticsScriptProps {
  slug: string;
}

const GrowthBookAnalyticsScript: FC<GrowthBookAnalyticsScriptProps> = ({ slug }) => {
  useEffect(() => {
    const script = document.createElement('script');
    script.innerHTML = `
            window.growthbook_config = window.growthbook_config || {};
            window.growthbook_config.attributes = {
                siteSlug: "${slug}"
            };
        `;
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, [slug]);

  return null;
};

export default GrowthBookAnalyticsScript;
